import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

type Role = {
  name: string;
  description: string;
  roleId?: string;
  level?: string;
  department?: string;
};

type RolesStore = {
  role: Role;
  roleId: string;
  setRole: (roles: Role) => void;
  setRoleId: (roleId: string) => void;
  resetRoleStore: () => void;
};

export const useRolesStore = create<RolesStore>()(
  persist(
    (set) => ({
      role: {
        name: "",
        description: "",
        roleId: "",
        level: "",
        department: "",
      },
      roleId: "",
      setRole: (role) => set({ role }),
      setRoleId: (roleId) => set({ roleId }),
      resetRoleStore: () =>
        set({
          role: { name: "", description: "", roleId: "", level: "", department: "" },
          roleId: "",
        }),
    }),
    {
      name: "roles-store",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
